import { ImportContainer } from '@/modules/ProductsImport';

const Import = (): JSX.Element => <ImportContainer />;

export default Import;
